<template>
  <!--投资有招-->
  <div>
    <header class="header">
      <div class="top">
        <div class="logo">
          <img src="../assets/img/logo1.png" class="img" alt="招商基金" />
          <!-- <img src="../assets/img/logo2.png" class="img" alt="投资者" /> -->
        </div>
        <div class="search"></div>
      </div>
      <ul class="nav">
        <li>
          <router-link to="/" class="a">首 页</router-link>
        </li>
        <li>
          <router-link to="/huodong" class="a">主题活动</router-link>
        </li>
        <li>
          <router-link to="/licai" class="a">理财课堂</router-link>
        </li>
        <li>
          <router-link to="/touzi" class="a sel">投资有招</router-link>
        </li>
      </ul>
    </header>

    <div class="sy_banner">
      <van-swipe class="sy_swipe" :autoplay="3000" indicator-color="#BEBDB9" :show-indicators="false" @change="onChange">
        <van-swipe-item v-for="(item, i) in bannerList" :key="i">
          <img src="../assets/img/004.png" class="img" />
        </van-swipe-item>
      </van-swipe>
      <div class="dots">
        <div class="nei">
          <i :class="i == current ? 'sel' : ''" v-for="(item, i) in bannerList" :key="i"></i>
        </div>
      </div>
    </div>

    <!--养老有招-->
    <div class="t_title">
      <span>养老有招</span>
      <router-link to="" class="more">更多></router-link>
    </div>
    <ul class="touzi_list">
      <li>
        <img src="../assets/img/del/006.png" class="img" />
        <div class="right">
          <div class="tit">养老有招的标题</div>
          <div class="desc">内容描述，内容描述，内容描述，内容</div>
        </div>
      </li>
      <li>
        <img src="../assets/img/del/006.png" class="img" />
        <div class="right">
          <div class="tit">阳光定投的标题</div>
          <div class="desc">内容描述，内容描述，内容描述，内容</div>
        </div>
      </li>
      <li>
        <img src="../assets/img/del/006.png" class="img" />
        <div class="right">
          <div class="tit">指数有招的标题</div>
          <div class="desc">内容描述，内容描述，内容描述，内容</div>
        </div>
      </li>
    </ul>

    <!--阳光定投-->
    <div class="t_title">
      <span>阳光定投</span>
      <router-link to="" class="more">更多></router-link>
    </div>
    <ul class="touzi_list">
      <li>
        <img src="../assets/img/del/006.png" class="img" />
        <div class="right">
          <div class="tit">标题标题标题</div>
          <div class="desc">内容描述，内容描述，内容描述，内容</div>
        </div>
      </li>
      <li>
        <img src="../assets/img/del/006.png" class="img" />
        <div class="right">
          <div class="tit">标题标题标题</div>
          <div class="desc">内容描述，内容描述，内容描述，内容</div>
        </div>
      </li>
      <li>
        <img src="../assets/img/del/006.png" class="img" />
        <div class="right">
          <div class="tit">标题标题标题</div>
          <div class="desc">内容描述，内容描述，内容描述，内容</div>
        </div>
      </li>
    </ul>

    <!--指数有招-->
    <div class="t_title">
      <span>指数有招</span>
      <router-link to="" class="more">更多></router-link>
    </div>
    <ul class="touzi_list">
      <li>
        <img src="../assets/img/del/006.png" class="img" />
        <div class="right">
          <div class="tit">标题标题标题</div>
          <div class="desc">内容描述，内容描述，内容描述，内容</div>
        </div>
      </li>
      <li>
        <img src="../assets/img/del/006.png" class="img" />
        <div class="right">
          <div class="tit">标题标题标题</div>
          <div class="desc">内容描述，内容描述，内容描述，内容</div>
        </div>
      </li>
      <li>
        <img src="../assets/img/del/006.png" class="img" />
        <div class="right">
          <div class="tit">标题标题标题</div>
          <div class="desc">内容描述，内容描述，内容描述，内容</div>
        </div>
      </li>
    </ul>

    <div class="di_tishi">
      <strong>风险提示 ：</strong><br />
      市场有风险，投资须谨慎。本网站相关观点为当前观点，未来可能随着市场的变化而变化，亦不构成任何投资建议及基金投资收益的保证。
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      current: 0,
      bannerList: [
        { src: '../static/img/001.png' },
        { src: '../static/img/001.png' },
        { src: '../static/img/001.png' },
        { src: '../static/img/001.png' },
      ],
    }
  },
  methods: {
    //轮播
    onChange(index) {
      this.current = index
    },
  },
}
</script>

<style lang="less" scoped>
.header {
  position: sticky;
  top: 0;
  z-index: 1000;
  margin-bottom: -0.6rem;
  .top {
    height: 1rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 0 0 0.3rem;
    background: #fff;
    .logo {
      display: flex;
      height: 1rem;
      align-items: center;
      .img {
        max-height: 0.46rem;
        margin-right: 0.4rem;
      }
    }
    .search {
      width: 1rem;
      height: 1rem;
      background: url(../assets/img/search.png) no-repeat center center;
      background-size: 0.41rem;
    }
  }
  .nav {
    width: 100%;
    background: url(../assets/img/bg_01.png) no-repeat left top;
    background-size: 100% 100%;
    height: 0.96rem;
    line-height: 0.8rem;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    li {
      padding: 0;
      margin: 0;
      width: 50%;
      text-align: center;
      height: 0.96rem;
      display: flex;
    }
    .a {
      width: 100%;
      color: #fff;
      font-size: 0.28rem;
      height: 0.8rem;
      display: inline-block;
      line-height: 0.8rem;
      position: relative;
      &.sel {
        font-weight: bold;
        background: url(../assets/img/bg_02.png) no-repeat center 85%;
        background-size: auto 0.02rem;
      }
    }
  }
}
.main {
  padding: 0 0.32rem;
}
.sy_banner {
  position: relative;
  .sy_swipe {
    .img {
      display: block;
      width: 100%;
    }
  }
  .dots {
    width: 100%;
    position: absolute;
    bottom: 0;
    z-index: 10;
    height: 0.4rem;
    background-size: 100% 100%;
    text-align: right;
    padding-right: 0.3rem;
    line-height: 20px;
    box-sizing: border-box;
    display: flex;
    flex-direction: row-reverse;
    .nei {
      display: flex;
    }
    i {
      width: 0.1rem;
      height: 0.1rem;
      background: #fff;
      border-radius: 5px;
      display: inline-block;
      margin-left: 8px;
      transition: 0.4s;
    }
    .sel {
      width: 0.9rem;
    }
  }
}
.t_title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 0.3rem;
  box-sizing: border-box;
  padding: 0 0.32rem;
  span {
    height: 0.74rem;
    line-height: 0.74rem;
    font-size: 0.3rem;
    color: #272a2c;
    font-weight: bold;
  }
  .more {
    line-height: 0.5rem;
    color: #666666;
    font-size: 0.22rem;
  }
}
.act_list {
  padding: 0 0.32rem;
  padding-bottom: 1rem;
  margin-bottom: -0.7rem;
  li {
    margin-bottom: 0.2rem;
    width: 100%;
    overflow: hidden;
    border-radius: 6px;
    position: relative;
    box-shadow: -2px 0.2rem 0.2rem 0px rgba(245, 219, 204, 0.74);
    .img {
      width: 100%;
      display: block;
    }
    .title {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      box-sizing: border-box;
      padding: 0 0.2rem;
      display: flex;
      align-items: center;
      flex-direction: row-reverse;
      color: #fff;
      line-height: 0.6rem;
      font-weight: bold;
      span {
        text-shadow: 0.03rem 0.03rem 0.07rem rgba(40, 39, 40, 0.34);
        font-size: 0.52rem;
      }
    }
  }
}
.bg1 {
  background: url(../assets/img/bg_06.png) no-repeat left bottom;
  background-size: 5.3rem;
}
.bg2 {
  background: url(../assets/img/bg_06.png) no-repeat right bottom;
  background-size: 5.3rem;
}
.bg3 {
  background: url(../assets/img/bg_07.png) no-repeat left bottom;
  background-size: 3.6rem;
}
.touzi_list {
  padding: 0 0.32rem;
  padding-bottom: 1rem;
  margin-bottom: -0.7rem;
  li {
    margin-bottom: 0.18rem;
    background: #fff;
    border-radius: 6px;
    display: flex;
    justify-content: space-between;
    overflow: hidden;
    position: relative;
    align-items: center;
    box-shadow: -2px 0.2rem 0.2rem 0px rgba(245, 219, 204, 0.74);
  }
  .img {
    width: 2.9rem;
    height: 1.5rem;
    object-fit: cover;
    flex-shrink: 0;
  }
  .type {
    position: absolute;
    top: 3px;
    right: 0.15rem;
    line-height: 0.24rem;
    background: #f7eaec;
    padding: 0 5px;
    color: #e34f66;
    font-size: 0.18rem;
  }
  .right {
    padding: 0.2rem;
    width: 100%;
    .tit {
      padding-left: 0.16rem;
      background: url(../assets/img/bg_05.png) no-repeat left top;
      background-size: 0.08rem;
      color: #4d4d4d;
      font-size: 0.3rem;
      line-height: 0.5rem;
    }
    .desc {
      color: #999999;
      line-height: 0.24rem;
      font-size: 0.2rem;
      padding-left: 0.16rem;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      line-clamp: 2;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    }
  }
}

.di_tishi {
  padding: 0.6rem 0.32rem;
  color: rgba(153, 153, 153, 0.59);
  line-height: 0.28rem;
  font-size: 0.18rem;
  font-weight: normal;
}
</style>
